export default (state = [], action) => {
  switch (action.type) {
    case "UPDATE_CRIMINAL_HISTORY":
      return action.payload.criminalHistory;
    default:
      return state;
  }
}
